import React from "react";
import { Layout } from "../../containers";
import { Main } from "../../components";

function Home() {
  return (
    <Layout>
      <Main />
    </Layout>
  );
}

export default Home;
